import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CellularReportUnsavedGuard implements CanDeactivate<{ confirmDiscardChanges(): boolean }> {
  canDeactivate(component: { confirmDiscardChanges(): boolean }): boolean {
    return component.confirmDiscardChanges();
  }
}
